import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  reportsDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './board-approve-dialog.controller';
import template from './board-approve-dialog.html';
import messageTpl from './assessment.analysis-date.messages.html';

class dialogService {
  getOptions($event, {
    assessmentId,
    assessmentName,
    isNavantaUser,
    users
  }) {
    return {
      controller,
      controllerAs: 'praApproveDialogVM',
      locals: {
        assessmentId,
        assessmentName,
        isNavantaUser,
        users
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.boardApproveDialog', [
  alerts,
  praDataService,
  constants,
  ssDialogService,
  loaderService,
  reportsDataService,
])
  .service('praBoardApproveDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.analysis-date.messages.html', messageTpl);
  })
  .name;
